import * as base from './base.jsx';
import * as ReactBootstrap from 'react-bootstrap';

class FileUpload extends base.BaseComponent {
  constructor(props) {
    super(props);

    if (props.file) {
      this.state = {
        "complete": true,
        "file": props.file
      }
    }
    else {
      this.state = {
        "allowSelect": true,
        "complete": false,
        "progress": 0
      };
    }

    this.topic = props.topic == undefined ? "fileUploadEvent" : props.topic;
  }

  reset() {
    this.setState({
      "allowSelect": true,
      "complete": false,
      "progress": 0,
    });
  }

  onDelete(uuid) {
    $.ajax({
      url: `/files/delete/${uuid}`,
      method: "DELETE",
      dataType: "json",
      contentType: "application/json; charset=utf-8",
    })
    .done((data, textStatus) => {
      if (data.status >= 200 && data.status < 300) {
        this.setState((prevState, props) => {
          return {
            ...prevState,
            file: {
              ...prevState.file,
              deleted: true
            }
          }
        })
      } else {
        radio('showAlert').broadcast('warning', `Failed to delete file ${this.state.file.filename} with reason ${data.message}`)
      }
    })
    .fail((jqXHR, textStatus, errorThrown) => {
      radio('showAlert').broadcast('danger', `${textStatus}`)
    })
  }

  componentDidMount() {
    var domNode = ReactDOM.findDOMNode(this);

    var params = {
      url: "/files/upload/",
      dataType: "json",
      formData: this.props.formData,
      sequentialUploads: true,
      replaceFileInput: false,
      add: (e, data) => {
        let continueUpload = true;

        if (this.props.fileExtension) {
          const dotExtension = this.props.fileExtension.startsWith('.') ? this.props.fileExtension : `.${this.props.fileExtension}`;
          const filesWithRequiredExtension = data.files.filter(file => file.name.toLowerCase().endsWith(dotExtension.toLowerCase()));
          continueUpload = filesWithRequiredExtension.length === data.files.length;

          if (!continueUpload) {
            $(domNode).find("input.file-upload").val(null);
            this.setState({"errorMessage": ` Only files with '${dotExtension}' extension allowed`});
          }
        }

        if (continueUpload) {
          this.setState({
            "allowSelect": false,
            "errorMessage": null
          });

          radio(this.topic).broadcast({
            event: "add",
            component: this
          });

          return $.blueimp.fileupload.prototype.options.add.call(this.fileUpload, e, data);
        }
      },
      progress: (e, data) => {
        var percent = parseInt(data.loaded / data.total * 90, 10);

        this.setState({
          progress: percent,
          complete: false
        })

        radio(this.topic).broadcast({
          event: "progress",
          percent: percent,
          component: this
        });
      },
      done: (e, data) => {
        var result = data.result;
        if (this.props.callback) {
          this.props.callback(result);
        }

        if (result.status == 200) {
          this.setState({
            complete: true,
            progress: 100,
            file: result.data
          });

          radio(this.topic).broadcast({
            event: "complete",
            result: result,
            component: this
          });
        } else {
          this.failedFileUpload(e, data)
        }
      },
      fail: (e, data) => {
        this.failedFileUpload(e, data);
      }
    }

    params = $.extend(params, this.props.fileUploadSettings);
    this.fileUpload = $(domNode).find("input.file-upload").fileupload(params);
  }

  failedFileUpload(e, data, message = ` File upload failed, please try again`) {
    this.setState({
      "errorMessage": message,
      "allowSelect": true,
      "complete": false,
      "progress": 0
    });

    radio(this.topic).broadcast({
      event: "error",
      result: data.result,
      component: this
    });
  }

  fieldName() {
    return this.props.field_name ? this.props.field_name : "file";
  }

  render() {
    var buttonStyle = {
      display: this.state.allowSelect ? "" : "none"
    };

    if (this.state.complete) {
      return (this.state.file.deleted ? null :
        (
          <div className="file-upload row">
            <input type="hidden" name={this.fieldName()} value={this.state.file.uuid}/>
            <div className="file-name col-md-6">
              <i className="icon-clip-1"></i> 
              <a href={this.state.file.url}>
                {this.state.file.filename}
              </a>
            </div>
            <div className="file-actions col-md-2">
              <a className="file-remove btn btn-danger btn-sm" href="#" onClick={() => this.onDelete(this.state.file.uuid)}>
                <i className="glyphicon glyphicon-trash"></i>
                Remove
              </a>
            </div>
          </div>
        )
      )
    }
    return <div>
      <span className="file-upload">
        <span className="btn btn-primary btn-sm btn-file-upload" style={buttonStyle}>
          <span><i className="fa fa-fw fa-file-o"> </i> {this.props.title}</span>
          <input type="file" name={this.fieldName()} className="file-upload"></input>
        </span>

        {
          this.state.errorMessage ? null : (
            <span className="text-danger">{this.state.errorMessage}</span>
          )
        }

        {
          this.state.allowSelect ? null :(
            <ReactBootstrap.ProgressBar now={this.state.progress}/>
          )
        }
      </span>
    </div>
  }
}

FileUpload.defaultProps = {
  path: "/files/upload",
  title: "Upload file",
  topic: "fileUploadEvent",
  fieldName: "file"
}


class FileList extends base.BaseComponent {
  constructor(props) {
    super(props);

    var files = [];

    if (props.state && props.state.value) {
      // We already have a list of files
      files = props.state.value.map((file) => {
        return <FileUpload
          formData={this.props.formData}
          topic={this.props.topic}
          file={file}
          key={file.uuid ? file.uuid : 'new-file'}
        />
      });
    }

    this.state = {
      "files": files
    }

    radio(this.props.topic).subscribe(data => {
      this.fileUploadEvent(data)
    })
  }

  componentDidMount() {
    this.allowNewFile();
  }

  allowNewFile() {
    var files = this.state.files;
    if (!files) {
      files = [];
    }

    files.push(
      <FileUpload title="Upload file" formData={this.props.formData} topic={this.props.topic} />
    );

    this.setState({
      "files": files
    });
  }

  fileUploadEvent(data) {
    if (data.event == "add") {
      this.allowNewFile();
    }
  }

  fileList() {
    if (this.state.files) {
      return <div className="uploaded">
        { this.state.files }
      </div>
    }
    else {
      return <div></div>
    }
  }

  render() {
    return <div>
      { this.fileList() }
    </div>
  }
}

FileList.defaultProps = {
  allowRepeat: true,
  topic: "fileListFileUploadEvent"
}

module.exports = {
  FileUpload: FileUpload,
  FileList: FileList
}
